import { capitalize } from "common/api";

export const getDirectValue = (input) => ({ value: input.trim() });

export const asUnknown =
  (...fields) =>
  (error) =>
    console.error(error) ||
    Object.fromEntries(fields.map((field) => [field, "unknown"]));

const optionalPlural = (input) => input.replace("(s)", "s");
const asFieldName = (input) =>
  input.split(" ").map(optionalPlural).map(capitalize).join("");

const asFieldAndValue = (line) =>
  (([label, value = "unknown"]) => [asFieldName(label), value])(
    line.trim().split(/:\s+/)
  );

export const getTupleValues = (input) =>
  Object.fromEntries(input.trim().split("\n").map(asFieldAndValue));

export const getTwoColumnTupleValues = (input) =>
  JSON.parse('{' +
    input
      .trim()
      .replace(/([A-Za-z][A-Za-z6]+)/g, attribute => `,"${attribute}"`)
      .replace(',' , '')/*first*/
  + '}');

const asObjectOf = (fields) => (line) =>
  Object.fromEntries(
    line
      .trim()
      .split(/\s+/)
      .map((value, index) => [fields[index], value])
  );

const isFirst = (_, index) => index === 0;

export const getFirstRowValuesMatching = (matches) => (input) => {
  const [head, ...rows] = input.trim().split("\n");
  const fields = head.split(/\s+/).map(asFieldName);
  return rows.map(asObjectOf(fields)).find(matches);
};

export const getFirstRowValues = getFirstRowValuesMatching(isFirst);
